module.exports = __webpack_public_path__ + "static/media/img_jp.ec0ce315.png";